import { createStandaloneToast } from "@chakra-ui/react";
import axios, { AxiosInstance } from "axios";

import { appConfig } from "./../env-config";

const domain = appConfig.REACT_APP_AUTH0_DOMAIN;
const clientId = appConfig.REACT_APP_AUTH0_CLIENT_ID;
const audience = appConfig.REACT_APP_AUTH0_AUDIENCE;

const http: AxiosInstance = axios.create({
  baseURL: appConfig.REACT_APP_API_SUPPLIER_ENDPOINT,
  timeout: 99999999,
});

http.interceptors.request.use((req) => {
  const userInfos = JSON.parse(
    localStorage.getItem(
      `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
    )
  );
  if (userInfos) {
    req.headers.Authorization = `Bearer ${
      userInfos ? userInfos.body?.access_token : ""
    }`;
  }

  return req;
});

export default http;
